import { plusSquareIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const PlusO = createIcon({
  displayName: 'PlusO',
  paths: [
    'M768 170.667c47.104 0 85.333 38.229 85.333 85.333v512c0 47.104-38.229 85.333-85.333 85.333h-512c-47.104 0-85.333-38.229-85.333-85.333v-512c0-47.104 38.229-85.333 85.333-85.333h512zM256 768h512v-512h-512v512zM512 341.333c-23.552 0-42.667 19.115-42.667 42.667v85.333h-85.333c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h85.333v85.333c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-85.333h85.333c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-85.333v-85.333c0-23.552-19.115-42.667-42.667-42.667z'
  ],
  canvasPaths: canvasIconPaths(plusSquareIcon)
})
